export function extractToken(script = '') {
  const keyRegex = /([\w]{8}(-[\w]{4}){3}-[\w]{12})/g;
  const matchArr = script.match(keyRegex);

  return matchArr ? matchArr[0] : '';
}
